import React, { Fragment } from 'react';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';
import { FormattedMessage } from 'react-intl/dist';


const FallbackUIModal = props => {

    const handleHideClick = () => props.actions.hideModal();

    return (
        <Fragment>
            <h5>
                {'Needed type of Modal has\'t been provided'}
                <br/>
                <Button onClick={handleHideClick}>
                    <FormattedMessage id='button.close'/>
                </Button>
            </h5>
        </Fragment>
    );
};

export default FallbackUIModal;
